import { useParams } from 'react-router-dom';
import NotFound from '../../../features/NotFound/NotFoundPage';
import ConversationInputArea from './Components/ConversationInputArea';
import PageHeader from './Components/PageHeader';
import SupportConversation from './Components/SupportConversation';
import SupportTicketInfoProvider, { useTicketInfo } from './SupportTicketInfoProvider';

function PageContent() {
    const { supportTicketInfo, handleReload } = useTicketInfo();

    if (supportTicketInfo && Object.keys(supportTicketInfo).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="Support Ticket Not Found!"
                    btnTitle="Back To List"
                    path="/support-ticket"
                    className="h-full"
                />
            </div>
        );
    }

    return (
        <div className="inner_page_cont overflow-hidden">
            <PageHeader data={supportTicketInfo} handleReload={handleReload} />

            <div className="h-[calc(100%_-_144px)] overflow-y-auto custom-scrollbar">
                <ConversationInputArea data={supportTicketInfo} handleReload={handleReload} />
                <SupportConversation data={supportTicketInfo} handleReload={handleReload} />
            </div>
        </div>
    );
}

function SupportTicketInfoPage() {
    const { id } = useParams();

    return (
        <SupportTicketInfoProvider id={id}>
            <PageContent />
        </SupportTicketInfoProvider>
    );
}

export default SupportTicketInfoPage;
